angular.module('unica_material.material_services')

.factory('MaterialDeleteService', function ($http, getBaseApiURL) {

	var materialDeleteService = {};

	materialDeleteService.delete = function (materialId) {
		return $http({
			method: 'DELETE',
			url: getBaseApiURL + '/material/delete/' + materialId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});

	};

	return materialDeleteService;
});